RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    const PanelTitle = RivalIQ.views.ItemView.mixin({
        template: '#dashboardWidgetPngPanelTitleTemplate',
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },
        loadData: function () {
            const me = this;
            return App.utils.fetchCompanyData().done(function (companyData) {
                me.dashboardModel.companyData = companyData;
            });
        },
        serializeData: function () {
            const me = this;

            return {
                title: me.dashboardModel.getTitle(),
                subtitle: me.dashboardModel.getExportSubtitle()
            };
        },
        templateHelpers: function () {
            return RivalIQ.utils.emoji.getTemplateHelpers();
        }
    });

    views.PngPanel = RivalIQ.apps.Dashboard.views.PngPanel.extend({
        panelTitleView: PanelTitle
    });
});
